/* TOBOX cart terms. Native required validation also works without this script. */
(function () {
  'use strict';

  function clearError(checkbox) {
    checkbox.removeAttribute('aria-invalid');
    var error = document.getElementById('ToboxCartTermsError');
    if (error) error.hidden = true;
  }

  function resetTerms(itemCount) {
    var terms = document.querySelector('#cart [data-cart-terms]');
    var checkbox = document.getElementById('ToboxCartTerms');
    if (!terms || !checkbox) return;

    if (typeof itemCount === 'number') terms.dataset.itemCount = itemCount;
    var empty = Number(terms.dataset.itemCount) === 0;
    terms.hidden = empty;
    terms.querySelectorAll('input').forEach(function (input) {
      input.disabled = empty;
    });
    // Each changed cart and restored page needs an explicit, fresh choice.
    checkbox.checked = false;
    checkbox.defaultChecked = false;
    clearError(checkbox);
  }

  // Delegate to document so Shopify section reloads keep working.
  document.addEventListener('invalid', function (event) {
    if (event.target.id !== 'ToboxCartTerms') return;
    event.preventDefault();
    event.target.setAttribute('aria-invalid', 'true');
    var error = document.getElementById('ToboxCartTermsError');
    if (error) error.hidden = false;
    document.documentElement.classList.add('cart-active');
    var checkbox = event.target;
    window.requestAnimationFrame(function () { checkbox.focus(); });
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.id === 'ToboxCartTerms') clearError(event.target);
  });

  document.addEventListener('tobox:cart-updated', function (event) {
    resetTerms(event.detail.itemCount);
  });
  document.addEventListener('shopify:section:load', function () { resetTerms(); });
  window.addEventListener('pageshow', function () { resetTerms(); });
  resetTerms();
}());
